import React from 'react';
import { DragonBetMainLogoWrapper, DragonBetMainLogo } from './dragonbet.style';

export const DragonBetLogotype = (): JSX.Element => (
    <DragonBetMainLogoWrapper>
        <DragonBetMainLogo />
    </DragonBetMainLogoWrapper>
);
